import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import "./role.scss"; // 👈 role.scss rakha gaya hai
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import CUSTOMERIDIMAGE from "../../assets/71dfd03e2bc3d97ab6e9d15c83ddcf00.jpg";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Chip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { deleteCustomer, fetchCustomer } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import AddIcon from "@mui/icons-material/Add";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";

const RoleList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllCustomer, setAllCustomer] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllCustomer);

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        const response = await dispatch(
          fetchCustomer(page, ITEMS_PER_PAGE, search, status, "")
        );
        if (
          response &&
          response?.data &&
          response?.data?.data &&
          response?.data?.data?.length &&
          response?.isSuccess
        ) {
          setAllCustomer(response?.data?.data);
          setTotalCount(response?.data?.totalCount);
        } else {
          setAllCustomer([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.log(getAllCustomer);
        setAllCustomer([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [search, page, dispatch, status]);

  const gotoEdit = (id: string) => {
    navigate(`/edit-role/${id}`);
  };

  const handledeleteCustomer = async (id: string) => {
    const response = await dispatch(deleteCustomer(id));
    if (response && response.isSuccess) {
      const newCustomer = getAllCustomer.filter((item: any) => item._id !== id);
      setAllCustomer(newCustomer);
    }
  };

  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handledeleteCustomer(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };

  const navigateToaddcustomer = () => {
    navigate("/add-role");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="mt-3" style={{ flexShrink: 0 }}>
        <div className="role-management-header">
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              Role Management
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              Manage roles and permissions for your team
            </p>
          </div>
          <button className="add-role-btn" onClick={navigateToaddcustomer}>
            <AddIcon /> Add New Role
          </button>
        </div>

        <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <h5 className="fw-semibold">Roles</h5>
            <div className="my-2 search-box find-Box justify-content-between align-items-baseline pt-2" style={{ flexShrink: 0 }}>
              <div className="search-wrapper">
                <IoSearchOutline className="search-icon" />
                <input
                  placeholder="Type Role you want to search"
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <select
                onChange={(e) => setStatus(e.target.value)}
                className="form-select"
                style={{
                  width: "max-content",
                  height: "42px",
                  marginBottom: "15px",
                  marginRight: "10px",
                }}
                aria-label="Default select example"
              >
                <option selected value={""}>
                  All
                </option>
                <option value="Drivers">Drivers</option>
                <option value="Customers">Customers</option>
              </select>
            </div>
            <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
              <Table className="table px-0">
                <TableHead className="th p-0">
                  <TableRow className="table-h-row">
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      S.No
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Name
                      <FilterPopover column="name" filterType="text" currentValue={filters.name || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    {/* <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Passenger
                    </TableCell> */}
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Email
                      <FilterPopover column="email" filterType="text" currentValue={filters.email || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>

                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Company
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Location
                      <FilterPopover column="address.streetAddress" filterType="text" currentValue={filters["address.streetAddress"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    {/* <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Send Code
                    </TableCell> */}
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Role Type
                      <FilterPopover column="status" filterType="text" currentValue={filters.status || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody className="tb">
                    {filteredData.map((customer: any, index) => (
                      <TableRow key={index} className="t-row">
                        <TableCell>
                          {" "}
                          {(page - 1) * ITEMS_PER_PAGE + index + 1}
                        </TableCell>
                        <TableCell>
                          <span className="fw-semibold">
                            {customer.name || "--"}
                          </span>
                        </TableCell>
                        <TableCell>{customer.email || "--"}</TableCell>
                        <TableCell>Neksoft</TableCell>
                        <TableCell>
                          <span title={customer.address?.streetAddress}>
                            {customer.address?.streetAddress
                              ? customer.address.streetAddress.length > 10
                                ? customer.address.streetAddress.slice(0, 25) +
                                  "..."
                                : customer.address.streetAddress
                              : "--"}
                          </span>
                        </TableCell>

                        {/* <TableCell>
                          <Button
                            variant="contained"
                            endIcon={
                              <SendIcon style={{ fontSize: "15px" }} />
                            }
                            style={{
                              width: "120px",
                              height: "auto",
                              background: "#4285F4",
                              color: "#fff",
                              fontWeight: "500",
                              fontSize: "13px",
                              borderRadius: "12px",
                              textTransform: "none",
                            }}
                            component="a"
                            href={customer.whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Send Code
                          </Button>
                        </TableCell> */}
                        <TableCell>
                          <Chip
                            style={{
                              display: "inline-flex",
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.75rem",
                              lineHeight: "1rem",
                              fontWeight: 600,
                              borderRadius: "9999px",
                              backgroundColor: "#D1FAE5",
                              color: "#065F46",
                            }}
                            label={customer.status || "--"}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton className="icon-btn">
                            <EditIcon
                              onClick={() => gotoEdit(customer._id)}
                              style={{ color: "primary" }}
                              className="icons"
                            />
                          </IconButton>
                          <IconButton className="icon-btn-red">
                            <MdDelete
                              onClick={() => handleDeleteClick(customer._id)}
                              style={{ color: "red" }}
                              className="icons"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                    <ConfirmDialog
                      open={openDialog}
                      onClose={() => setOpenDialog(false)}
                      onConfirm={confirmDelete}
                    />

                    {filteredData.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No Customer Found.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </div>
          <nav style={{ flexShrink: 0 }}>
            <ul className="pagination justify-content-center">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"}`}
                >
                  <button className="page-link" onClick={() => setPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              {pageCount > 5 && (
                <>
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => setPage(pageCount)}
                    >
                      {pageCount}
                    </button>
                  </li>
                </>
              )}

              <li className={`page-item ${page === pageCount && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </Paper>
      </div>
    </div>
  );
};

export default RoleList;

